module.exports = __webpack_public_path__ + "static/media/ev11.cd0fc799.jpg";